import { User } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconUser(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <User />
    </IconWrapper>
  );
}
